<div class="container mb-4 {{class}}" [ngClass]="{'d-none': router.url === '/home-twelve'}">
    <div class="section-title">
        <span class="sub-title">{{'text_pricing_subtitle' | translate}}</span>
        <h2>{{'text_pricing_title' | translate}}</h2>
        <p>{{'text_pricing_detail' | translate}}</p>
    </div>
    <div class="row justify-content-center">

        <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-pricing-box box1">
                <div class="pricing-header">
                    <div class="icon">
                        <i class="flaticon-paper-plane"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                        </div>
                    </div>
                    <h3>{{'text_pricing_box1' | translate}}</h3>
                </div>
                <div class="pricing-features">
                    <ul>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_starter_text1' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_starter_text4' | translate}}
                        </li>

                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_starter_text3' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_starter_text2' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_starter_text5' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_starter_text6' | translate}}
                        </li>
                    </ul>
                </div>
                <div class="price">
                    990₺
                    <span>{{'text_monthly' | translate}}</span>
                </div>
                <a class="default-btn p1" href="https://panel.dotcrea.com/account/register"
                    target="_blank">{{'text_get_start_free'|translate}}</a>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-pricing-box box2">
                <div class="pricing-header">
                    <div class="icon">
                        <i class="flaticon-jigsaw"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                        </div>
                    </div>
                    <h3>{{'text_pricing_box2' | translate}}</h3>
                </div>
                <div class="pricing-features">
                    <ul>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_entrepreneur_text1' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_entrepreneur_text4' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_entrepreneur_text3' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_entrepreneur_text2' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_entrepreneur_text5' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_entrepreneur_text6' | translate}}
                        </li>
                    </ul>
                </div>
                <div class="price">
                    1990₺
                    <span>{{'text_monthly' | translate}}</span>
                </div>
                <a class="default-btn p2" href="https://panel.dotcrea.com/account/register"
                    target="_blank">{{'text_get_start_free'|translate}}</a>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-pricing-box box3">
                <div class="pricing-header">
                    <div class="icon">
                        <i class="flaticon-diamond"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                        </div>
                    </div>
                    <h3>{{'text_pricing_box3' | translate}}</h3>
                </div>
                <div class="pricing-features">
                    <ul>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text1' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text4' | translate}}
                        </li>

                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text3' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text2' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text5' | translate}}
                        </li>
                        <li class="close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text6' | translate}}
                        </li>
                    </ul>
                </div>
                <span class="badge text-success">{{'text_pricing_integration_popular'|translate}}</span> 
                <div class="price">
                    2490₺
                    <span>{{'text_monthly' | translate}}</span>
                </div>
                
                <a class="default-btn p3" href="https://panel.dotcrea.com/account/register"
                    target="_blank">{{'text_get_start_free'|translate}}</a>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="single-pricing-box box4">
                <div class="pricing-header">
                    <div class="icon">
                        <i class="flaticon-speed"></i>
                        <div class="circles-box">
                            <div class="circle-one"></div>
                        </div>
                    </div>
                    <h3>{{'text_kurumsal' | translate}}</h3>
                </div>
                <div class="pricing-features">
                    <ul>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text1' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text4' | translate}}
                        </li>

                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text3' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text2' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text5' | translate}}
                        </li>
                        <li class="check">
                            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor"
                                viewBox="0 0 512 512">
                                <path d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                                    style="fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:32px" />
                                <path
                                    d="M256,360a16,16,0,0,1-9-2.78c-39.3-26.68-56.32-45-65.7-56.41-20-24.37-29.58-49.4-29.3-76.5.31-31.06,25.22-56.33,55.53-56.33,20.4,0,35,10.63,44.1,20.41a6,6,0,0,0,8.72,0c9.11-9.78,23.7-20.41,44.1-20.41,30.31,0,55.22,25.27,55.53,56.33.28,27.1-9.31,52.13-29.3,76.5-9.38,11.44-26.4,29.73-65.7,56.41A16,16,0,0,1,256,360Z" />
                            </svg>
                            {{'text_professional_text6' | translate}}
                        </li>
                    </ul>
                </div>
                <div class="price">
                    4990₺
                    <span>{{'text_monthly' | translate}}</span>
                </div>
                <a class="default-btn p4" href="https://panel.dotcrea.com/account/register"
                    target="_blank">{{'text_get_start_free'|translate}}</a>
            </div>
        </div>

        <section class="project-start-area ptb-100 text-center">
            <p class="text_special">{{'text_special_request'|translate}}</p>
            <a target="_blank" href="https://api.whatsapp.com/send?phone=14164766110"
                class="menu-link  whatsapp_support btn btn-success">{{'text_contact_us'|translate}}</a>
            

        </section>


    </div>



    <div class="table-responsive pt-5 pricingCompareTable ePacks">
        <h2>{{'text_pricing_integration_all_features'|translate}}</h2><br>
        <table class="table table-hover">
            <tbody>
                <tr>
                    <th class="thBase p-3">{{'text_pricing_integration_packages'|translate}}</th>
                    <th class="thPck _0 text-center align-middle position-relative"> {{'text_pricing_integration_starter'|translate}}</th>
                    <th class="thPck _1 text-center align-middle position-relative">{{'text_pricing_integration_entrepreneur'|translate}}</th>
                    <th class="thPck _2 text-center align-middle position-relative"><span
                        class="badge">{{'text_pricing_integration_popular'|translate}}</span> {{'text_pricing_integration_professional'|translate}}</th>
                    <th class="thPck _3 text-center align-middle position-relative"> {{'text_pricing_integration_corporate'|translate}}</th>
                </tr>
                <tr>
                    <th class="thBase p-3">{{'text_pricing_integration_pricing'|translate}}</th>
                    <td class="tdPrice _0 text-center"><b>990 ₺</b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                    <td class="tdPrice _1 text-center"><b>1990 <small>₺</small></b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                    <td class="tdPrice _2 text-center"><b>2490<small>₺</small></b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                    <td class="tdPrice _3 text-center"><b>4990<small>₺</small></b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0">
                        <b>{{'text_pricing_integration_marketplace_integrations'|translate}}</b>
                        <small class="d-block">
                            <img width="44" height="44" src="/assets/img/svg/trendyol.svg" alt="Trendyol Entegrasyonu"
                                title="Trendyol Entegrasyonu">
                            <img width="44" height="44" src="/assets/img/svg/hepsiburada.svg"
                                alt="Hepsiburada Entegrasyonu"
                                title="Hepsiburada Entegrasyonu - Türkiye'nin öncü e-ticaret platformu">
                            <img width="44" height="44" src="/assets/img/svg/n11.svg" alt="N11 Entegrasyonu"
                                title="N11 Entegrasyonu">
                            <img width="44" height="44" src="/assets/img/svg/ciceksepeti.svg"
                                alt="Çiçeksepeti Entegrasyonu" title="Çiçeksepeti Entegrasyonu">
                            <img width="44" height="44" src="/assets/img/svg/pazarama.svg" alt="Pazarama Entegrasyonu"
                                title="Pazarama Entegrasyonu">
                            <img width="44" height="44" src="/assets/img/svg/pttavm.svg" alt="PttAvm Entegrasyonu"
                                title="PttAvm Entegrasyonu">
                        </small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0">
                        <b>{{'text_pricing_integration_xml_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_xml_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0">
                        <b>{{'text_pricing_integration_cargo_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_cargo_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _no _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0">
                        <b>{{'text_pricing_integration_ecommerce_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_ecommerce_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _no _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0">
                        <b>{{'text_pricing_integration_accounting_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_accounting_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _no _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0">
                        <b>{{'text_pricing_integration_ecommerce_site'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_ecommerce_site_desc'|translate}}</small>
                        </td>
                    <td class="tdDurum _no _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _2 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr class="b-none">
                    <td  class="tdDet p-3 b-none title-background" colspan="5"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3 title-background" colspan="5"><b>{{'text_pricing_integration_marketplace_integrations'|translate}}</b></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_trendyol_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_trendyol_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_hepsiburada_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_hepsiburada_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_n11_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_n11_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_ciceksepeti_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_ciceksepeti_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_pazarama_integration'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_pazarama_integration_desc'|translate}}</small>
                    </td>
                    <td class="tdDurum _yes _0 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td  class="tdDet p-3 b-none title-background" colspan="5"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3 title-background" colspan="5"><b>{{'text_pricing_integration_cargo_integrations'|translate}}</b></td>
                </tr>
                
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_aras_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_yurtici_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_mng_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_surat_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_sendeo_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_ups_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_hepsijet_cargo'|translate}}</b></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _1 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td  class="tdDet p-3 b-none title-background" colspan="5"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3 title-background" colspan="5"><b>{{'text_pricing_integration_ecommerce_integrations'|translate}}</b></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_rgs_yazilim'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_rgs_yazilim_desc'|translate}}</small></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_shopify'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_shopify_desc'|translate}}</small></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td  class="tdDet p-3 b-none title-background" colspan="5"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3 title-background" colspan="5"><b>{{'text_pricing_integration_accounting_integrations'|translate}}</b></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_parasut'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_parasut_desc'|translate}}</small></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_bizimhesap'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_bizimhesap_desc'|translate}}</small></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _2 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <td  class="tdDet p-3 b-none title-background" colspan="5"></td>
                </tr>
                <tr>
                    <td class="tdDet p-3 title-background" colspan="5"><b>{{'text_pricing_integration_ecommerce_sites'|translate}}</b></td>
                </tr>
                <tr>
                    <td class="tdDet p-3" colspan="0"><b>{{'text_pricing_integration_ecommerce_sites1'|translate}}</b>
                        <small class="d-block">{{'text_pricing_integration_ecommerce_sites1_desc'|translate}}</small></td>
                    <td class="tdDurum _no  _0 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _1 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _no _2 text-center"><img src="/assets/img/x-lg.svg"></td>
                    <td class="tdDurum _yes _3 text-center"><img src="/assets/img/check-circle-fill.svg"></td>
                </tr>
                <tr>
                    <th class="thBase p-3"></th>
                    <th class="thPck _0 text-center align-middle position-relative lnh-50">{{'text_pricing_integration_starter'|translate}}</th>
                    <th class="thPck _1 text-center align-middle position-relative lnh-50">{{'text_pricing_integration_entrepreneur'|translate}}</th>
                    <th class="thPck _2 text-center align-middle position-relative lnh-50">{{'text_pricing_integration_professional'|translate}}</th>
                    <th class="thPck _3 text-center align-middle position-relative lnh-50">{{'text_pricing_integration_corporate'|translate}}</th>
                </tr>
                <tr>
                    <th class="thBase p-3"></th>
                    <td class="tdPrice _0 text-center lnh-50"><b>990 ₺</b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                    <td class="tdPrice _1 text-center lnh-50"><b>1990 <small>₺</small></b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                    <td class="tdPrice _2 text-center lnh-50"><b>2490<small>₺</small></b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                    <td class="tdPrice _3 text-center lnh-50"><b>4990<small>₺</small></b> <sub>/{{'text_pricing_integration_month'|translate}}</sub></td>
                </tr>
                <tr>
                    <th class="thBase p-3"></th>
                    <td class="tdPrice _0 text-center h-100"><a href="https://panel.dotcrea.com/account/register" target="_blank" class="default-btn p1">{{'text_pricing_integration_startnow'|translate}}</a></td>
                    <td class="tdPrice _1 text-center h-100"><a href="https://panel.dotcrea.com/account/register" target="_blank" class="default-btn p1">{{'text_pricing_integration_startnow'|translate}}</a></td>
                    <td class="tdPrice _2 text-center h-100"><a href="https://panel.dotcrea.com/account/register" target="_blank" class="default-btn p1">{{'text_pricing_integration_startnow'|translate}}</a></td>
                    <td class="tdPrice _3 text-center h-100"><a href="https://panel.dotcrea.com/account/register" target="_blank" class="default-btn p1">{{'text_pricing_integration_startnow'|translate}}</a></td>
                </tr>
            </tbody>
        </table>
    </div>


</div>